import { Link, StaticQuery, graphql } from 'gatsby'
import React from 'react'
import SpeakerProfile from 'components/SpeakerProfile'

const Speaker = props => (
  <StaticQuery
    query={graphql`
      query SpeakerQuery {
        allSpeakersJson {
          edges {
            node {
              id
              type
              name
              company
              title
              twitter
              facebook
              github
              profile
              image
            }
          }
        }
      }
    `}
    render={data => {
      const speakers = data.allSpeakersJson.edges.map(edge => edge.node)
      const keynoteSpeakers = speakers.filter(
        speaker => speaker.type === 'keynote'
      )
      const panelists = speakers.filter(speaker => speaker.type === 'panelist')
      const submissions = speakers.filter(
        speaker => speaker.type === 'submission'
      )
      const sponsors = speakers.filter(speaker => speaker.type === 'sponsor')
      return (
        <section className="ts-speakers section-bg">
          <a id="speakers" className="anchor" />
          <div className="container">
            {props.detail || (
              <div className="row">
                <div className="col-lg-12">
                  <h2 className="section-title">
                    <span>Speakers</span>
                    登壇者
                  </h2>
                </div>
              </div>
            )}
            <div>
              {props.detail ? (
                <h2 className="section-title">
                  <span>Keynote Speakers</span>
                  基調講演
                </h2>
              ) : (
                <h3 className="section-subtitle">基調講演</h3>
              )}
              <div className="row">
                {keynoteSpeakers.map((speaker, index) => (
                  <div key={index} className="col-lg-6">
                    <SpeakerProfile speaker={speaker} />
                  </div>
                ))}
              </div>
            </div>
            <div>
              {props.detail ? (
                <h2 className="section-title">
                  <span>Panelists</span>
                  パネルディスカッション
                </h2>
              ) : (
                <h3 className="section-subtitle">パネルディスカッション</h3>
              )}
              <div className="row">
                {panelists.map((speaker, index) => (
                  <div key={index} className="col-lg-3">
                    <SpeakerProfile speaker={speaker} />
                  </div>
                ))}
              </div>
            </div>
            {props.detail && (
              <div className="submission">
                {props.detail ? (
                  <h2 className="section-title">
                    <span>Submissions</span>
                    公募セッション
                  </h2>
                ) : (
                  <h3 className="section-subtitle">公募セッション</h3>
                )}
                <div className="row">
                  {submissions.map((speaker, index) => (
                    <div key={index} className="col-lg-3 col-md-4 col-6">
                      <SpeakerProfile speaker={speaker} />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {props.detail && (
              <div className="submission">
                {props.detail ? (
                  <h2 className="section-title">
                    <span>Sponsors</span>
                    スポンサーセッション
                  </h2>
                ) : (
                  <h3 className="section-subtitle">スポンサーセッション</h3>
                )}
                <div className="row">
                  {sponsors.map((speaker, index) => (
                    <div key={index} className="col-lg-3 col-md-4 col-6">
                      <SpeakerProfile speaker={speaker} />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          {props.detail || (
            <div className="schedule-listing-btn">
              <Link to="/speakers" className="btn">
                More Details
              </Link>
            </div>
          )}
        </section>
      )
    }}
  />
)

export default Speaker
